import _ from 'lodash';
export const animationDelayDefault = 400;
const getHeight = node => node.scrollHeight;
const setHeight = (node, height) => {
  node.style.height = "".concat(height, "px");
};
const collapse = node => setHeight(node, 0);
const flushHeight = node => setHeight(node, getHeight(node));
const simpleAnimationMap = {
  none: {},
  highlight: {
    classNames: 'highlight',
    timeout: {
      enter: animationDelayDefault
    },
    exit: false
  },
  insert: {
    classNames: 'insert',
    timeout: {
      enter: animationDelayDefault,
      exit: animationDelayDefault / 2
    }
  },
  expand: () => {
    let height;
    return {
      classNames: 'expand',
      onEnter: node => {
        height = getHeight(node);
        collapse(node);
      },
      onEntering: node => {
        setHeight(node, height);
      },
      onExit: flushHeight,
      onExiting: collapse,
      timeout: {
        enter: animationDelayDefault,
        exit: animationDelayDefault / 2
      }
    };
  },
  reveal: {
    classNames: 'reveal',
    transitionWrapper: 'reveal_base',
    timeout: animationDelayDefault
  }
};
export function resolveAnimationFromName(name) {
  if (_.isObject(name) || _.isFunction(name)) {
    return name;
  }
  return simpleAnimationMap[name] || simpleAnimationMap.none;
}